/**
 * ? findFlow
 *  * Utilizado em FlowEdition e FlowViewerModel. O seu prósito é retornar um
 *  * fluxo especifico em meio as entidades do estado global, seus parametros são
 *  * basicamente o estado atual e um _id do fluxo selecionado.
 */

export const getPaneFlow = (state) => state.flows.pane.flow;

export const getCurrent = (state) => state.flows.pane.flow.current;

export const getPaneStatus = (state) => state.flows.pane.status;

export const getFlowById = ({ flowsState, flowId }) => {
  const flows = flowsState.pane.flow;
  const allFlows = [flows.main, ...flows.versions];

  if (!allFlows) {
    return;
  }

  return allFlows.find((item) => item._id === flowId);
};

export const getDefaultPaneFlow = (state) => {
  const flows = state.flows.pane.flow;

  const main = flows.main;
  const versions = flows.versions;

  if (!main | !versions) {
    return null;
  }

  if (!main.default) {
    return main;
  } else {
    return versions.find((item) => item._id === main.default);
  }
};

export const getAllFlowsTitleNames = (state) => {
  const flows = state.flows.pane.flow;
  const main = flows.main;
  const versions = flows.versions;

  const dFlow = getDefaultPaneFlow(state);

  if (!dFlow) return;

  return [main, ...versions].map(
    (item) =>
      (item = {
        title: item.title,
        _id: item._id,
        default: dFlow._id === item._id ? true : false,
        type: item.type,
      })
  );
};

export const getDashboardFlows = (state) => state.flows.dashboard.flows;

export const getDashboardStatus = (state) => state.flows.dashboard.status;

export const getModelsPage = (state) => state.flows.dashboard.pages;

/**
 * ? filterFlow
 * * Utilizado em DashboardModel. O seu propósito é filtrar a lista de
 * * fluxos modelos e exibir a nova lista conforme o campo título for
 * * digitado. Os seus parâmetros é a entidade global de fluxos modelo
 * * e o título a ser pesquisado
 */
export const filterFlows = (flows, title) => {
  // if (title !== undefined && flows !== undefined) {
  //   return flows?.filter((e) => e?.title?.match(title));
  // }
};
